import {useEffect} from 'react';

import {PeepDuplicateBadge} from '../../shared/header/peep-duplicate-badge';

import {useGetAccountDuplicateStatus} from '../graphql/hooks/use-get-account-duplicate-status';

interface Props {
    accountId: string;
}

export function AccountDuplicateWrapper(props: Props) {
    const {accountDuplicateStatus, isLoading, refetch} = useGetAccountDuplicateStatus(
        props.accountId
    );

    useEffect(() => {
        const handleDuplicateStatusUpdate = () => {
            refetch();
        };

        $('body').on(Nut.events.card.duplicateStatusWasUpdated, handleDuplicateStatusUpdate);

        return () => {
            $('body').off(Nut.events.card.duplicateStatusWasUpdated, handleDuplicateStatusUpdate);
        };
    }, [refetch]);

    if (isLoading || !accountDuplicateStatus || !accountDuplicateStatus.hasDuplicates) {
        return null;
    }

    return (
        <PeepDuplicateBadge
            entityName='Accounts'
            entityId={props.accountId}
            parentEntityName='Contacts'
        />
    );
}
